<template>
  <v-container class="pa-0 ma-0 mb-3">
    <v-expansion-panel :disabled="disabled">
      <slot name="header">
        <v-expansion-panel-header v-slot="{}" class="pt-0 pb-0 pl-0 pr-4">
          <v-list-item style="width: 80%;" dense>
            <v-list-item-icon class="mr-4 ">
              <FlagIconWrapper :flag="MachineJobData.Flag">
                <v-icon size="20" v-text="'$machine'">
                </v-icon>
              </FlagIconWrapper>
            </v-list-item-icon>
            <v-list-item-content v-if="MachineJobData" class="py-0">
              <v-list-item-title class="my-auto">
                <h4 v-text="MachineJobData.Machine ? MachineJobData.Machine.DisplayName : 'Name error, missing machine'"
                  class="useThemeTextColor nowrapheader" />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-expansion-panel-header>
        <QTextArea v-model="MachineJobData.CustomerComment"
          :label="$t('servicesystem.common_objects.machine.edit.customer_comment')" disabled class="mx-5 mb-2 mt-0">
        </QTextArea>
      </slot>
      <v-alert v-if="MachineJobData && MachineJobData.TechnicianComment" dense dark color="pink darken-3"
        icon="mdi-information-variant" class="mb-0 py-0 px-0"
        :class="MachineJobData.InvoiceComment ? 'rounded-b-0' : ''" border="left">
        <template v-slot:prepend>
          <div></div>
        </template>
        <area-li :label="$t('servicesystem.common_objects.machine.edit.technician_comment')"
          :value="MachineJobData.TechnicianComment.trim()" :expandonhover="true">
        </area-li>
      </v-alert>
      <v-alert v-if="MachineJobData && MachineJobData.InvoiceComment" dense dark color="teal"
        icon="mdi-information-variant" class="mb-0 py-0 px-0"
        :class="MachineJobData.TechnicianComment ? 'rounded-t-0' : ''" border="left">
        <template v-slot:prepend>
          <div></div>
        </template>
        <area-li :label="$t('servicesystem.common_objects.machine.edit.invoice_comment')"
          :value="MachineJobData.InvoiceComment.trim()" :expandonhover="null">
        </area-li>
      </v-alert>
      <v-container v-if="MachineJobData && ContractsLicense" class="pa-0">
        <v-divider v-if="!MachineJobData.InvoiceComment && !MachineJobData.TechnicianComment" />
        <v-row no-gutters>
          <v-col cols="0" v-if="ContractsLicense">
            <MachineContractHoverCard
              :id="(MachineJobData && MachineJobData.Machine) ? MachineJobData.Machine.Id : null">
            </MachineContractHoverCard>
          </v-col>
          <v-col cols="auto">
            <switch-li :label="$t('servicesystem.common_objects.machine.service_agreement')"
              :value="MachineJobData.Machine.ServiceAgreement">
            </switch-li>
          </v-col>
        </v-row>
      </v-container>

      <v-expansion-panel-content>
        <v-divider />
        <v-container v-if="MachineJobData" class="px-0 py-2">

          <v-container class="pa-0">
            <v-row no-gutters>
              <v-col>
                <edit-li :label="$t('servicesystem.common_objects.supplier_failure_code.supplier_failure_code')"
                  :value="MachineJobData.SupplierFailiureCode ? (MachineJobData.SupplierFailiureCode.Code + ' ' + MachineJobData.SupplierFailiureCode.Description) : null">
                </edit-li>
              </v-col>
              <v-col>
                <edit-li :label="$t('servicesystem.common_objects.repair_place.repair_place')"
                  :value="MachineJobData.RepairPlace ? MachineJobData.RepairPlace.Description : null">
                </edit-li>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <edit-li :label="$t('servicesystem.common_objects.job.job_category')"
                  :value="MachineJobData.JobCategory ? MachineJobData.JobCategory.Name : null">
                </edit-li>
              </v-col>
              <v-col>
                <edit-li :label="$t('servicesystem.common_objects.warranty_type.warranty_type')"
                  :value="MachineJobData.WarrantyType ? MachineJobData.WarrantyType.Description : null">
                </edit-li>
              </v-col>
            </v-row>
          </v-container>

          <v-divider />

          <template v-if="MachineJobData.Machine">
            <v-card class="rounded-0" style="width: 100%;" flat>
              <MachineListItem :machine="MachineJobData.Machine" disabled :showServiceAgreement="false">
              </MachineListItem>
            </v-card>

            <v-divider />

            <v-container class="px-5">
              <v-row no-gutters>
                <v-col>
                  <QTextField v-model="MachineJobData.Machine.Name"
                    :label="$t('servicesystem.common_objects.machine.location')" :disabled="true">
                  </QTextField>
                </v-col>
                <v-col>
                  <QTextField v-model="MachineJobData.Machine.Facility"
                    :label="$t('servicesystem.common_objects.machine.facility')" :disabled="true">
                  </QTextField>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col>
                  <QTextField v-model="MachineJobData.Machine.Qrcode"
                    :label="$t('servicesystem.common_objects.machine.qr_code')" :disabled="true">
                  </QTextField>
                </v-col>
                <v-col>
                  <QTextField v-model="MachineJobData.Machine.SerialNumber"
                    :label="$t('servicesystem.common_objects.machine.serial_number')" :disabled="true">
                  </QTextField>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col>
                  <QTextArea v-model="MachineJobData.Machine.Note"
                    :label="$t('servicesystem.common_objects.machine.note')" :disabled="true">
                  </QTextArea>
                </v-col>
                <v-col>
                  <QTextField v-model="MachineJobData.Machine.YearlyBudget"
                    :label="$t('servicesystem.common_objects.machine.yearly_budget')" :disabled="true">
                  </QTextField>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col>
                  <QTextField :value="i18nFormatDate(MachineJobData.Machine.BoughtDate)"
                    :label="$t('servicesystem.common_objects.machine.purchase_date')" :disabled="true">
                  </QTextField>
                </v-col>
                <v-col>
                  <QTextField :value="i18nFormatDate(MachineJobData.Machine.InstallationDate)"
                    :label="$t('servicesystem.common_objects.machine.installation_date')" :disabled="true">
                  </QTextField>
                </v-col>
                <v-col>
                  <QTextField :value="i18nFormatDate(MachineJobData.Machine.WarrantyExpiresDate)"
                    :label="$t('servicesystem.common_objects.machine.warranty_expires')" :disabled="true">
                  </QTextField>
                </v-col>
              </v-row>
            </v-container>
          </template>

        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>


<script>
import moment from "moment";
import EditLi from "@/components/Inputs/EditableListItem.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
import AreaLi from "@/components/Inputs/AreaListItem.vue";
import MachineContractHoverCard from "@/views/job/newjob/cards/machines/MachineContractHoverCard.vue";
import MachineListItem from "@/components/ListItems/MachineListItem.vue";
import FlagIconWrapper from "@/components/Buttons/FlagIconWrapper.vue";

export default {
  name: "MachineJobPreview",
  props: {
    MachineJobData: Object,
  },
  components: {
    EditLi,
    AreaLi,
    SwitchLi,
    MachineContractHoverCard,
    MachineListItem,
    FlagIconWrapper,
  },

  data: () => ({
    disabled: false,
  }),

  mounted() { },

  methods: {
    toDateString(dt) {
      return moment(dt).format("LL");
    },

    toTimeString(dt) {
      return moment(dt).format("LT");
    },
  },

  computed: {},

  watch: {},
};
</script>